import Disabled from "./Disabled";
import Hidden from "./Hidden";
import PermissionHOC from './PermissionHOC'
import UI from './MappingPermissionByType'
import GridColumn from './GridColumn'
import { Can } from './Can'

export { Can }
export default { PermissionHOC, Disabled, Hidden, UI, GridColumn }